import React from "react";
import List from "../../directorate/ui/List";

export default function PastorReportList() {
  const data = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
  return <List data={data} />;
}
